import tableStore from '../../store/TableStore';
import { WEvent } from './WEvent';

export class WTableViewerSyncEvent extends WEvent {
  tableId: string;
  viewersCount: number;

  constructor(event: WTableViewerSyncEvent) {
    super(event.tableId, event.eventType, event.eventTime);
    Object.assign(this, event);
  }

  applyWebsocketChanges = (): Promise<void> =>
    tableStore.findActiveTableById(this.tableId).then(table => {
      table.setViewersCount(this.viewersCount);
    });
}
